(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ujima-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ujima-video-hero')) {
    customElements.define('ujima-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.control = this.querySelector('.ujima-vh__playback');
        if (!this.video || !this.control) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.video.muted = true;
        this.control.hidden = false;
        this.updateControl = () => {
          const paused = this.video.paused;
          this.control.querySelector('[data-play-label]').hidden = !paused;
          this.control.querySelector('[data-pause-label]').hidden = paused;
        };
        this.control.addEventListener('click', () => {
          if (this.video.paused) this.video.play().catch(this.updateControl);
          else this.video.pause();
        }, options);
        this.video.addEventListener('play', this.updateControl, options);
        this.video.addEventListener('pause', this.updateControl, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.video.pause();
        }, options);
        this.updateControl();
        if (this.dataset.autoplay === 'true' && !this.motion.matches) {
          this.video.play().catch(this.updateControl);
        }
      }
      disconnectedCallback() {
        if (this.events) this.events.abort();
        if (this.video) this.video.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
